import { Modal } from "antd";
import * as React from "react";

export const RenderModalCompleteRegistration = ((props:{isOpen?: boolean, onOk?:()=>void, onCancel?:()=>void, email?: string})=>{
    return(
        <Modal
            title="Complete Registration"
            centered
            open={props.isOpen}
            onOk={() => props.onOk()}
            onCancel={() =>props.onCancel()}
        >
            <p>Do you want to confirm the user registration request for <b>{props.email}</b>?</p>
        </Modal>
    )
})